import axios from 'axios'

class Loadmore {
	page = 2
	is_loadmore = false
	list_wrap = document.querySelector('.list-wrap')
	url_loadmore = this.list_wrap?.dataset['url_loadmore']
	constructor() {
		// this.loadmoreByAuto()
		this.loadmoreByClick()

	}

	loadmoreByClick() {
		try {
			const _this = this
			let can_loadmore = !!(_this.list_wrap && _this.url_loadmore)
			let view_more_btn = document.querySelector('.view-more')
			view_more_btn?.addEventListener('click', () => {
				if (can_loadmore && _this.is_loadmore === false) {
					_this.is_loadmore = true
					view_more_btn?.closest('div')?.remove()
					if (document.querySelector('.loading')) {
						document.querySelector('.loading').classList.remove('hidden')
					}
					console.log('_this.url_loadmore :>> ', _this.url_loadmore);
					axios
						.get(_this.url_loadmore, {
							params: {
								page: _this.page,
								q: typeof query !== 'undefined' ? query : ''
							},
						})
						.then((response) => {
							if (document.querySelector('.loading')) {
								document.querySelector('.loading').remove()
							}
							_this.is_loadmore = false
							_this.list_wrap.insertAdjacentHTML('beforeend', response.data)
							_this.page++
							_this.loadmoreByClick()
							// _this.handleArticleSapo()
						})
						.catch((err) => {
							console.log('err ===>', err)
						})
				}
			})
		} catch (error) {
			console.log('Loadmore.loadmoreByClick', { message: err.message })
		}
	}
	loadmoreByAuto() {
		try {
			const _this = this

			let can_loadmore = !!(_this.list_wrap && _this.url_loadmore)
			let view_more_btn = document.querySelector('.view-more')
			window.onscroll = function () {
				if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 1000) {
					if (can_loadmore && _this.is_loadmore === false) {
						_this.is_loadmore = true
						view_more_btn?.closest('div')?.remove()
						if (document.querySelector('.loading')) {

							document.querySelector('.loading').classList.remove('hidden')
						}
						axios
							.get(_this.url_loadmore, {
								params: {
									page: _this.page,
									q: typeof query !== 'undefined' ? query : ''
								},
							})
							.then((response) => {
								if (document.querySelector('.loading')) {

									document.querySelector('.loading').remove()
								}
								_this.is_loadmore = false
								_this.list_wrap.insertAdjacentHTML('beforeend', response.data)
								_this.page++
								// _this.handleArticleSapo()
								if (_this.page <= 3) {
									_this.loadmoreByAuto()
								} else {
									window.onscroll = function (evt) {
										evt.preventDefault();
										_this.loadmoreByClick()
									}

								}
							})
							.catch((err) => {
								console.log(err);
							})
					}
				}
			}
		} catch (error) {
			console.log('Loadmore.loadmoreByAuto', { message: err.message })
		}
	}

	handleArticleSapo() {
		try {
			let horizontal_articles = document.querySelectorAll('.article-horizontal')
			horizontal_articles.forEach((article) => {
				let img_height = article.querySelector('.thumbnail-wrap img').clientHeight
				let title_height = article.querySelector('.title-link').clientHeight
				let category_wrap_height = article.querySelector('.category-wrap').clientHeight
				let sapo = article.querySelector('.sapo')
				let sapo_line_height = sapo?.computedStyleMap().get('line-height').value
				let sapo_margin_top = sapo?.computedStyleMap().get('margin-top').value
				let sapo_height = img_height - (title_height + category_wrap_height) - sapo_margin_top
				let sapo_line = Math.floor(sapo_height / sapo_line_height)
				Object.assign(sapo.style, {
					'-webkit-line-clamp': sapo_line
				})
			})
		} catch (error) {
			console.log('App.handleArticleSapo', { message: error.message })
		}
	}
}

export default window.addEventListener('DOMContentLoaded', function (evt) {
	new Loadmore()
})
